module.exports = __webpack_public_path__ + "static/media/calendar.0cfd00bb.svg";